



































































































































import { cloneDeep } from 'lodash-es';
import changeLogMixin from '@adobe/edex/frontend/views/course/settings/mixin';
import { checkObjectArrayDiff, getID } from '@adobe/edex/frontend/views/course/settings/constants';
import SelectCard from '@adobe/edex/frontend/views/course/settings/course-settings-select-card.vue';
import Dropzone from '@adobe/edex/frontend/components/common/file-dropzone.vue';

const MODAL_WIDTH = 656;

const getInitialState = initialCourse => ({
  badges: initialCourse.badges,
  credlyBadges: initialCourse.credlyBadges,
  points: cloneDeep(initialCourse.settings.points),
  surveyURL: initialCourse.assets.survey.url,
  certificateURL: initialCourse.assets.certificate.url,
});

export default {
  mixins: [changeLogMixin],
  props: {
    initialCourse: {
      type: Object,
      required: true,
    },
  },
  data() {
    return getInitialState(this.initialCourse);
  },
  components: {
    SelectCard,
    Dropzone,
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    onMetaChanged({ name, data }) {
      this[name] = data;
    },
    onUploadComplete({ file }) {
      this.certificateURL = file.storagePath;
      this.$modal.hide('course-certificate-modal');
    },
    resetChanges() {
      Object.assign(this.$data, getInitialState(this.initialCourse));
    },
  },
  watch: {
    'points.perCourseCompletion': function (current, prev) {
      if (prev !== current) {
        this.onChange({
          name: 'perCourseCompletion',
          data: Math.max(0, current),
          path: ['settings', 'points', 'perCourseCompletion'],
          hasDiff:
            this.initialCourse.settings.points.perCourseCompletion !== current,
        });
      }
    },
    'points.perWorkshop': function (current, prev) {
      if (prev !== current) {
        this.onChange({
          name: 'perWorkshop',
          data: Math.max(0, current),
          path: ['settings', 'points', 'perWorkshop'],
          hasDiff: this.initialCourse.settings.points.perWorkshop !== current,
        });
      }
    },
    badges(current, previous) {
      if (previous !== current) {
        this.onChange({
          name: 'badges',
          data: current.map(getID),
          hasDiff: checkObjectArrayDiff(this.initialCourse.badges, current),
        });
      }
    },
     credlyBadges(current, previous) {
      if (previous !== current) {
        this.onChange({
          name: 'credlyBadges',
          data: current.map(getID),
          hasDiff: checkObjectArrayDiff(this.initialCourse.credlyBadges, current),
        });
      }
    },
    surveyURL(current, prev) {
      if (prev !== current) {
        this.onChange({
          name: 'surveyURL',
          data: current,
          path: ['assets', 'survey', 'url'],
          hasDiff: this.initialCourse.assets.survey.url !== current,
        });
      }
    },
    certificateURL(current, prev) {
      if (prev !== current) {
        this.onChange({
          name: 'certificateURL',
          data: current,
          path: ['assets', 'certificate', 'url'],
          hasDiff: this.initialCourse.assets.certificate.url !== current,
        });
      }
    },
  },
};
